<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6">
          <div class="clearfix">
            <h1 class="float-left display-3 mr-4">404</h1>
            <h4 class="pt-3">Oops! You're lost.</h4>
            <p class="text-muted">The page you are looking for was not found.<br/>Let's go back <a :href="baseurl">home</a>.</p>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>

const envi = process.env
export default {
  name: 'Page404',
  data() {
    return {
      baseurl: envi.VUE_APP_BASEURL
    }
  }
}
</script>
